<template>
  <v-layout column>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header class="question">
          {{ item.question }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="answer">
          {{ item.answer }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-layout>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style scoped>
.question {
  font-weight: 400;
  background-color: #f6f7f9;
}
.answer {
  /* width: 90%; */
  background-color: #f6f7f9;
}
.round-corners {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
</style>
